import React from "react";
import Link from "next/link";
import {
  LandingSection,
  SectionHeader,
} from "./landing/landing-ui";

const audiences = [
  {
    title: "Operations and process owners",
    description:
      "Teams drowning in documents, handoffs, and exception handling who need software that fits the way work already moves.",
  },
  {
    title: "Product and engineering leads",
    description:
      "Leaders who want production AI with clear architecture, evaluation, and ownership, not a demo that dies after launch.",
  },
  {
    title: "Domain-heavy enterprises",
    description:
      "Logistics, aviation, marine, supply chain, and similar environments where context and system of record matter more than novelty.",
  },
];

function WhoWeHelp() {
  return (
    <LandingSection muted>
      <SectionHeader
        title="Who we help"
        lead="We work best with organizations that have a real operational problem, access to systems and data, and an owner ready to run what we ship."
      />
      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {audiences.map((item) => (
          <div key={item.title} className="border-t border-line pt-5">
            <h3 className="text-lg font-semibold text-ink">{item.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-ink-muted">
              {item.description}
            </p>
          </div>
        ))}
      </div>
      <p className="mt-10 text-sm text-ink-muted">
        Not sure if you are a fit?{" "}
        <Link href="/how-we-work" className="font-semibold text-[#1c8c80] no-underline hover:underline">
          See how engagements work
        </Link>{" "}
        or{" "}
        <Link href="/contact" className="font-semibold text-[#1c8c80] no-underline hover:underline">
          tell us about the workflow
        </Link>
        .
      </p>
    </LandingSection>
  );
}

export default WhoWeHelp;
